// App.jsx
import React, { Suspense } from 'react';
import { Canvas } from '@react-three/fiber';
import Experience from './Experience'; // your main 3D scene
import Loader from './Loader'; // your loading UI component

export default function App() {
  return (
    <Canvas
      camera={{
        fov: 45,
        near: 0.1,
        far: 2000,
        position: [-3, 1.5, 4]
      }}
    >
      <Suspense fallback={<Loader />}>
        <Experience />
      </Suspense>
    </Canvas>
  );
}
